import { NativeError, ProjectAsset, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { HttpError } from 'src/errors/HttpError';
import { PDF_METADATA } from 'src/modules/common/codecs/PdfMetadata';
import { getAssetUrl } from 'src/modules/common/sagas/utils/getAssetUrl';
import { PdfMetadata } from 'src/modules/common/types/PdfMetadata';
import { createWorkerHandler } from 'src/modules/worker/utils/createWorkerHandler';
import { call } from 'typed-redux-saga';

export function* getPdfMetadata(
  file: ProjectAsset,
): SagaIterator<PdfMetadata> {
  try {
    const url = yield* call(getAssetUrl, file.id);
    const response = yield* call(fetch, url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
    });
    if (!response.ok) {
      throw new HttpError(response);
    }

    const content = yield* call([response, response.blob]);
    return yield* call(doOnWorker, content);
  } catch (error) {
    throw new RuntimeError('Could not get PDF metadata', { file }, NativeError.wrap(error));
  }
}

const doOnWorker = createWorkerHandler(
  '/pdf-meta-worker.js',
  PDF_METADATA,
)<Blob>;
